import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';
import {DashboardStudy, DashboardUser} from '../../types/dashboard.types';

/** Describes the state of the dashboard. */
export interface DashboardStateModel {
  /** The progress status of the loading user data process. */
  loadDashboardUserProgress: PROGRESS_STATUSES;

  /** The dashboard user data. */
  dashboardUser: DashboardUser;

  /** The last error that occurred during the loading of the user data. */
  lastLoadDashboardUserError: UnknownError;

  /** The progress status of the loading study details process. */
  loadDashboardStudyDetailsProgress: PROGRESS_STATUSES;

  /** The dashboard study details. */
  dashboardStudyDetails: DashboardStudy;

  /** The last error that occurred during the loading of the study details. */
  lastLoadDashboardStudyDetailsError: UnknownError;
}

/** Default values for dashboard state initialization and reset. */
export const dashboardStateDefaults: DashboardStateModel = {
  loadDashboardUserProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  dashboardUser: null,
  lastLoadDashboardUserError: null,

  loadDashboardStudyDetailsProgress: PROGRESS_STATUSES.NOT_INITIALIZED,
  dashboardStudyDetails: null,
  lastLoadDashboardStudyDetailsError: null,
};
